<template>
  <div class="ma-4">
    <div class="mb-3">
      <span class="main-title">SUMMARY | &nbsp;</span>
      <span class="submain-title">Order report</span>
    </div>
    <searchOrderReport @getBetweenDate="getBetweenDate($event)" />
    <orderReportFood :between_date="between_date" />
    <OrderReportFreeDelivery :between_date="between_date" />
    <orderReportMess :between_date="between_date" />
    <orderReportSummary :between_date="between_date" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import searchOrderReport from "@/components/back-office/Report/SearchBar/SearchOrderReport";
import OrderReportFreeDelivery from "@/components/back-office/Report/OrderReportFreeDelivery";
import orderReportFood from "@/components/back-office/Report/OrderReportFood";
import orderReportMess from "@/components/back-office/Report/OrderReportMess";
import orderReportSummary from "@/components/back-office/Report/OrderReportSummary";
export default {
  data() {
    return {
      csv_labels: {
        order_id: "",
        order_code: "WENM36RGO0A1",
        order_time_start: "17-06-2019 10:40:58",
        order_customer_full_name: "fon Customer",
        order_rider_full_name: "fon testRider",
        order_store: "WATER WALK SURATTHANI, บ้านก๋วยเตี๋ยวซีฟู้ด BY ป้าทิ้ง",
        order_net_price: 837,
        order_status: 6,
        order_note: ""
      },

      json_data: [
        {
          name: "Tony Peña",
          city: "New York",
          country: "United States",
          birthdate: "1978-03-15",
          phone: {
            mobile: "1-541-754-3010",
            landline: "(541) 754-3010"
          }
        },
        {
          name: "Thessaloniki",
          city: "Athens",
          country: "Greece",
          birthdate: "1987-11-23",
          phone: {
            mobile: "+1 855 275 5071",
            landline: "(2741) 2621-244"
          }
        }
      ],
      between_date: {
        start: null,
        end: null
      }
    };
  },
  created() {
    this.searchReport();
  },
  destroyed() {
    if (this.$route.fullPath.split("/")[5] != "order_report") {
      this.$store.commit("fetchReportDashboard/resetState");
    }
  },
  computed: {
    ...mapState({
      search_config: state => state.fetchReportDashboard.search_config,
      food_order_report: state => state.fetchReportDashboard.food_order_report,
      messenger_order_report: state =>
        state.fetchReportDashboard.messenger_order_report,
      food_summary: state => state.fetchReportDashboard.food_summary
    })
  },
  components: {
    OrderReportFreeDelivery,
    searchOrderReport,
    orderReportFood,
    orderReportMess,
    orderReportSummary
  },
  methods: {
    getBetweenDate(json_date) {
      this.between_date.start = json_date.start;
      this.between_date.end = json_date.end;
    },
    async searchReport() {
      if (
        this.search_config.order_type &&
        this.search_config.order_status &&
        this.search_config.datetime_start &&
        this.search_config.datetime_end
      ) {
        await this.$store.dispatch(
          "fetchReportDashboard/fetchOrderReport",
          this.search_config
        );
        this.getBetweenDate({
          start: this.search_config.datetime_start,
          end: this.search_config.datetime_end
        });
      }
    }
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "Dashboard report",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/main_dashboard"
      },
      {
        text: "Order report",
        disabled: true,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/order_report"
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  }
};
</script>

<style scoped>
.main-title {
  font-size: 22px;
  font-weight: bold;
}
.submain-title {
  font-size: 20px;
  color: #707070;
}
</style>
